import { styled } from "styled-components";

const Wrapper = styled.div`
  div {
    position: fixed;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    background: var(--grey-200);
    pointer-events: none;
    animation: var(--transition);
    box-shadow: inset 0 0 10px 10px var(--text-color);
    z-index: 999999;
  }
`;
export default Wrapper;
